import { render } from "./ResetPasswordChange.vue?vue&type=template&id=567c40f4"
import script from "./ResetPasswordChange.vue?vue&type=script&lang=js"
export * from "./ResetPasswordChange.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__